
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30438',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30438",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.54812",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8105",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11562",
  "I18n": "static-7.1634",
  "quartz": "static-1.7137",
  "quartz-config": "static-1.915",
  "quartz-core": "static-1.6356",
  "react-dlb": "static-1.80",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.816",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54799",
  "feedback-utils": "static-1.54803",
  "forms-embed-utils-lib": "static-1.4552",
  "forms-utils-lib": "static-1.12740",
  "foundations-assets": "static-1.4957",
  "foundations-components": "static-1.8098",
  "foundations-theming": "static-1.4520",
  "hub-http": "static-1.6309",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11869",
  "icons": "static-2.651",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.3983",
  "raven": "static-3.5925",
  "react": "static-7.187",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16770",
  "react-select-plus": "static-1.106",
  "react-utils": "static-2.5409",
  "react-virtualized": "static-2.100",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.488",
  "tinymce-plugins": "static-1.57710",
  "transmute": "static-2.85",
  "ui-images": "static-2.1174",
  "UIComponents": "static-3.8508",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3466",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3414",
  "quartz-webpack": "static-1.3361",
  "foundations-theming-specialty": "static-1.2236",
  "property-description-translator": "static-1.3927",
  "HeadJS": "static-2.766",
  "framer-motion": "static-1.73",
  "hs-test-utils-bend-plugin": "static-1.3216",
  "msw": "static-1.39",
  "testing-library": "static-1.153",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.222",
  "moment-timezone": "static-5.84",
  "jasmine": "static-4.4413",
  "jasmine-runner": "static-1.6549",
  "dispatcher": "static-1.138",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.841",
  "hubspotter-http": "static-1.4717",
  "mobile-manifest-mixins": "static-1.540",
  "module-federation": "static-1.24",
  "quartz-auth": "static-1.812",
  "quartz-head": "static-1.802",
  "quartz-i18n": "static-1.812",
  "quartz-routing": "static-1.567",
  "quartz-test": "static-1.812",
  "quartz-tracking": "static-1.516",
  "trellis-components": "static-1.2173",
  "ui-fonts": "static-1.824",
  "usage-tracker-container": "static-1.7426",
  "usage-tracker-core": "static-1.7286",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.157",
  "conversations-skeleton-state": "static-1.7337",
  "reference-resolvers": "static-1.8262",
  "sanitize-text": "static-1.8232",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10451",
  "sanitize": "static-1.4564",
  "outpost": "static-1.4259",
  "rpc-client-utils": "static-1.4743",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4367",
  "floating-ui": "static-1.57",
  "hs-story-utils": "static-1.9510",
  "react-aria": "static-1.67",
  "react-create-root-preference": "static-1.32",
  "tanstack-table": "static-1.56",
  "trellis-assets": "static-1.2154",
  "bend-plugin-foundations-theming": "static-1.3003",
  "foundations-theming-base": "static-1.3505",
  "stylex": "static-1.34",
  "hs-locale-management": "static-1.147",
  "csstype": "static-1.50",
  "web-vitals": "static-1.7",
  "ai-components-ui-library": "static-1.9171",
  "atom": "static-1.5162",
  "codemirror": "static-5.96",
  "content-assistance-lib": "static-1.7886",
  "ContentUtils": "static-1.68604",
  "data-token-picker": "static-1.16554",
  "file-manager-components": "static-1.23838",
  "FileManagerCore": "static-1.39337",
  "FileManagerLib": "static-1.39478",
  "frontend-preferences-client": "static-1.8014",
  "hub-http-contrib": "static-1.3129",
  "interframe": "static-3.4847",
  "layout-dnd-components": "static-1.12605",
  "layout-dnd-utils": "static-1.11580",
  "property-translator": "static-1.5483",
  "react-codemirror": "static-1.10715",
  "react-colorpicker": "static-2.10296",
  "reference-resolvers-lite": "static-1.8186",
  "rich-text-lib": "static-1.19972",
  "tinymce-data": "static-1.40681",
  "tinymce-themes": "static-1.56566",
  "ui-addon-emoji-picker": "static-1.9975",
  "ui-addon-sales-email": "static-1.5298",
  "ui-brand-identity-lib": "static-1.15584",
  "bender-build-tools": "static-1.3278",
  "hub-http-shared-msw-handlers": "static-1.10173",
  "hubspotter-http-shared-msw-handlers": "static-1.10171",
  "usage-tracker-session-replay": "static-1.5122",
  "base-ui": "static-1.12",
  "react-day-picker": "static-1.4",
  "trellis-theming": "static-1.1027",
  "tanstack-virtual": "static-1.31",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.153",
  "chirp-fetch": "static-1.1975",
  "chatspot-core": "static-1.21709",
  "copilot-toolkit": "static-1.11353",
  "customer-data-objects-ui-components": "static-1.13119",
  "data-fetching-client": "static-1.9750",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4848",
  "ui-addon-video-player": "static-1.8791",
  "ui-coaching-tips": "static-1.28803",
  "usage-tracker": "static-1.7436",
  "cms-field-types": "static-1.4900",
  "content-icons-ui": "static-1.2250",
  "integrations-lib": "static-1.16438",
  "customer-data-objects": "static-1.7765",
  "apollo-dlb": "static-3.86",
  "apollo-link-hub-http": "static-2.4740",
  "apollo-stack-hubspot": "static-3.87",
  "graphql": "static-1.83",
  "immer": "static-1.33",
  "immerable": "static-1.4242",
  "ui-addon-iframeable": "static-1.9150",
  "video-components-external": "static-1.11559",
  "video-data-lib": "static-1.35217",
  "audio-components": "static-1.6044",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29452",
  "FileManagerImages": "static-1.36989",
  "foundations-components-legacy": "static-1.1123",
  "html-to-image": "static-1.55",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "reselect": "static-2.16",
  "salesImages": "static-1.526",
  "ui-universal-auth": "static-1.9080",
  "urlinator": "static-1.4624",
  "video-components": "static-1.13561",
  "video-embed": "static-1.36051",
  "ts-schema": "static-1.4146",
  "ContentData": "static-1.68679",
  "layout-data-lib": "static-1.9905",
  "react-dnd-compat": "static-1.4702",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1630",
  "external-options-client-types": "static-1.4199",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.6977",
  "hs-promise-utils": "static-1.5679",
  "inbound-db-properties-service-client": "static-1.3911",
  "NamespacedHubStyle": "static-2.9124",
  "growth-onboarding-confetti": "static-1.3154",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11239",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "breeze-engine-lib": "static-1.1001",
  "magpie-lib": "static-1.5610",
  "magpie-types": "static-1.5070",
  "simple-logging-lib": "static-1.3138",
  "avatar-components": "static-1.2585",
  "customer-data-ui-utilities": "static-1.9913",
  "growth-onboarding-feedback-components": "static-1.6667",
  "flux-actions": "static-1.343",
  "hubspot-apollo-client": "static-1.4965",
  "integrations-error-boundary-lib": "static-1.13853",
  "integrations-tracking-lib": "static-1.5694",
  "laboratory-lib": "static-3.7243",
  "native-integrations-shared-strings": "static-1.7869",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10309",
  "unified-auth": "static-1.594",
  "navigation-messaging": "static-1.7563",
  "content-media-composition-data-lib": "static-1.12598",
  "content-media-compositions": "static-2.16605",
  "idb-keyval": "static-1.45",
  "media-bridge-lib": "static-1.19071",
  "unified-auth-core-lib": "static-1.876",
  "social-insights-client-types": "static-1.22294",
  "advanced-menus-core": "static-1.15265",
  "advanced-menus-lib": "static-1.12184",
  "ExportDialog": "static-6.10470",
  "ui-memberships-settings-lib": "static-1.34279",
  "conditional-properties-service-client": "static-1.3863",
  "crm-pipelines-api-client-types": "static-1.4204",
  "fdsr-migration-layer": "static-1.96",
  "framework-builder-read-service-client": "static-1.4071",
  "framework-data-schema-quick-fetch": "static-1.6882",
  "inbound-db-meta-service-client": "static-1.3652",
  "multi-currency-client-types": "static-1.3757",
  "persist-promise": "static-1.3787",
  "foundations-components-test-utils": "static-1.5581",
  "breeze-engine-core": "static-1.279",
  "ably": "static-2.2",
  "highlight.js": "static-1.80",
  "reactive-lib": "static-1.813",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.424",
  "universal-page-editor-lib": "static-1.3105",
  "ads-unified-auth-lib": "static-1.243",
  "google-sheets-integration-lib": "static-1.491",
  "microsoft-drive-integration-lib": "static-1.631",
  "slack-ui-library": "static-1.10480",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3817",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15264",
  "simple-menus-lib": "static-1.16781",
  "crm-record-cards-service-types": "static-1.3656",
  "location-customization-utils-lib": "static-1.9511",
  "react-flip-move": "static-1.72"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30438",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.54812",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8105",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11562",
  "I18n": "/I18n/static-7.1634",
  "quartz": "/quartz/static-1.7137",
  "quartz-config": "/quartz-config/static-1.915",
  "quartz-core": "/quartz-core/static-1.6356",
  "react-dlb": "/react-dlb/static-1.80",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.816",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54799",
  "feedback-utils": "/feedback-utils/static-1.54803",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4552",
  "forms-utils-lib": "/forms-utils-lib/static-1.12740",
  "foundations-assets": "/foundations-assets/static-1.4957",
  "foundations-components": "/foundations-components/static-1.8098",
  "foundations-theming": "/foundations-theming/static-1.4520",
  "hub-http": "/hub-http/static-1.6309",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11869",
  "icons": "/icons/static-2.651",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.3983",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.187",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16770",
  "react-select-plus": "/react-select-plus/static-1.106",
  "react-utils": "/react-utils/static-2.5409",
  "react-virtualized": "/react-virtualized/static-2.100",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.488",
  "tinymce-plugins": "/tinymce-plugins/static-1.57710",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1174",
  "UIComponents": "/UIComponents/static-3.8508",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3466",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3414",
  "quartz-webpack": "/quartz-webpack/static-1.3361",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2236",
  "property-description-translator": "/property-description-translator/static-1.3927",
  "HeadJS": "/HeadJS/static-2.766",
  "framer-motion": "/framer-motion/static-1.73",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3216",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.153",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.222",
  "moment-timezone": "/moment-timezone/static-5.84",
  "jasmine": "/jasmine/static-4.4413",
  "jasmine-runner": "/jasmine-runner/static-1.6549",
  "dispatcher": "/dispatcher/static-1.138",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.841",
  "hubspotter-http": "/hubspotter-http/static-1.4717",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.540",
  "module-federation": "/module-federation/static-1.24",
  "quartz-auth": "/quartz-auth/static-1.812",
  "quartz-head": "/quartz-head/static-1.802",
  "quartz-i18n": "/quartz-i18n/static-1.812",
  "quartz-routing": "/quartz-routing/static-1.567",
  "quartz-test": "/quartz-test/static-1.812",
  "quartz-tracking": "/quartz-tracking/static-1.516",
  "trellis-components": "/trellis-components/static-1.2173",
  "ui-fonts": "/ui-fonts/static-1.824",
  "usage-tracker-container": "/usage-tracker-container/static-1.7426",
  "usage-tracker-core": "/usage-tracker-core/static-1.7286",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.157",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7337",
  "reference-resolvers": "/reference-resolvers/static-1.8262",
  "sanitize-text": "/sanitize-text/static-1.8232",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10451",
  "sanitize": "/sanitize/static-1.4564",
  "outpost": "/outpost/static-1.4259",
  "rpc-client-utils": "/rpc-client-utils/static-1.4743",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4367",
  "floating-ui": "/floating-ui/static-1.57",
  "hs-story-utils": "/hs-story-utils/static-1.9510",
  "react-aria": "/react-aria/static-1.67",
  "react-create-root-preference": "/react-create-root-preference/static-1.32",
  "tanstack-table": "/tanstack-table/static-1.56",
  "trellis-assets": "/trellis-assets/static-1.2154",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3003",
  "foundations-theming-base": "/foundations-theming-base/static-1.3505",
  "stylex": "/stylex/static-1.34",
  "hs-locale-management": "/hs-locale-management/static-1.147",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.7",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9171",
  "atom": "/atom/static-1.5162",
  "codemirror": "/codemirror/static-5.96",
  "content-assistance-lib": "/content-assistance-lib/static-1.7886",
  "ContentUtils": "/ContentUtils/static-1.68604",
  "data-token-picker": "/data-token-picker/static-1.16554",
  "file-manager-components": "/file-manager-components/static-1.23838",
  "FileManagerCore": "/FileManagerCore/static-1.39337",
  "FileManagerLib": "/FileManagerLib/static-1.39478",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8014",
  "hub-http-contrib": "/hub-http-contrib/static-1.3129",
  "interframe": "/interframe/static-3.4847",
  "layout-dnd-components": "/layout-dnd-components/static-1.12605",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11580",
  "property-translator": "/property-translator/static-1.5483",
  "react-codemirror": "/react-codemirror/static-1.10715",
  "react-colorpicker": "/react-colorpicker/static-2.10296",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8186",
  "rich-text-lib": "/rich-text-lib/static-1.19972",
  "tinymce-data": "/tinymce-data/static-1.40681",
  "tinymce-themes": "/tinymce-themes/static-1.56566",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9975",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5298",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15584",
  "bender-build-tools": "/bender-build-tools/static-1.3278",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10173",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10171",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5122",
  "base-ui": "/base-ui/static-1.12",
  "react-day-picker": "/react-day-picker/static-1.4",
  "trellis-theming": "/trellis-theming/static-1.1027",
  "tanstack-virtual": "/tanstack-virtual/static-1.31",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.153",
  "chirp-fetch": "/chirp-fetch/static-1.1975",
  "chatspot-core": "/chatspot-core/static-1.21709",
  "copilot-toolkit": "/copilot-toolkit/static-1.11353",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13119",
  "data-fetching-client": "/data-fetching-client/static-1.9750",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4848",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8791",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28803",
  "usage-tracker": "/usage-tracker/static-1.7436",
  "cms-field-types": "/cms-field-types/static-1.4900",
  "content-icons-ui": "/content-icons-ui/static-1.2250",
  "integrations-lib": "/integrations-lib/static-1.16438",
  "customer-data-objects": "/customer-data-objects/static-1.7765",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4740",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.87",
  "graphql": "/graphql/static-1.83",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4242",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9150",
  "video-components-external": "/video-components-external/static-1.11559",
  "video-data-lib": "/video-data-lib/static-1.35217",
  "audio-components": "/audio-components/static-1.6044",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29452",
  "FileManagerImages": "/FileManagerImages/static-1.36989",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1123",
  "html-to-image": "/html-to-image/static-1.55",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-2.16",
  "salesImages": "/salesImages/static-1.526",
  "ui-universal-auth": "/ui-universal-auth/static-1.9080",
  "urlinator": "/urlinator/static-1.4624",
  "video-components": "/video-components/static-1.13561",
  "video-embed": "/video-embed/static-1.36051",
  "ts-schema": "/ts-schema/static-1.4146",
  "ContentData": "/ContentData/static-1.68679",
  "layout-data-lib": "/layout-data-lib/static-1.9905",
  "react-dnd-compat": "/react-dnd-compat/static-1.4702",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1630",
  "external-options-client-types": "/external-options-client-types/static-1.4199",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6977",
  "hs-promise-utils": "/hs-promise-utils/static-1.5679",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3911",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9124",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3154",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11239",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1001",
  "magpie-lib": "/magpie-lib/static-1.5610",
  "magpie-types": "/magpie-types/static-1.5070",
  "simple-logging-lib": "/simple-logging-lib/static-1.3138",
  "avatar-components": "/avatar-components/static-1.2585",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9913",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6667",
  "flux-actions": "/flux-actions/static-1.343",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4965",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13853",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5694",
  "laboratory-lib": "/laboratory-lib/static-3.7243",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7869",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10309",
  "unified-auth": "/unified-auth/static-1.594",
  "navigation-messaging": "/navigation-messaging/static-1.7563",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12598",
  "content-media-compositions": "/content-media-compositions/static-2.16605",
  "idb-keyval": "/idb-keyval/static-1.45",
  "media-bridge-lib": "/media-bridge-lib/static-1.19071",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.876",
  "social-insights-client-types": "/social-insights-client-types/static-1.22294",
  "advanced-menus-core": "/advanced-menus-core/static-1.15265",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12184",
  "ExportDialog": "/ExportDialog/static-6.10470",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34279",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3863",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4204",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.96",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4071",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6882",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3652",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3757",
  "persist-promise": "/persist-promise/static-1.3787",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5581",
  "breeze-engine-core": "/breeze-engine-core/static-1.279",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.80",
  "reactive-lib": "/reactive-lib/static-1.813",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.424",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3105",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.243",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.491",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.631",
  "slack-ui-library": "/slack-ui-library/static-1.10480",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3817",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15264",
  "simple-menus-lib": "/simple-menus-lib/static-1.16781",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3656",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9511",
  "react-flip-move": "/react-flip-move/static-1.72"
}
};
